import { createAction, props } from '@ngrx/store';
import { SensorTypeModel } from 'src/app/core/sensor-type.model';

export namespace SensorActions {
  export const loadSensorTypes = createAction('[SensorType API] Load Sensor Types');

  export const loadSensorTypesSuccess = createAction(
    '[SensorType API] Load Sensor Types For Dropdown Success',
    props<{ sensorTypes: SensorTypeModel[] }>(), // Updated type
  );

  export const loadSensorTypesFailure = createAction(
    '[SensorType API] Load Sensor Types For Dropdown Failure',
    props<{ error: any }>(),
  );
}
